import { defineStore } from 'pinia';
import packageJson from '/package.json';

export const SearchModes = {
  NONE: "NONE",
  KEYWORD: "KEYWORD",
  COORDINATE: "COORDINATE",
  ADVANCED_SHINRINBO: "ADVANCED_SHINRINBO",
  ADVANCED_RINDO: "ADVANCED_RINDO",
  ADVANCED_MORI_NO_CHIKARA: "ADVANCED_MORI_NO_CHIKARA",
  ADVANCED_KEIEI_KEIKAKU: "ADVANCED_KEIEI_KEIKAKU",
  ADVANCED_RINCHI_KAIHATSU: "ADVANCED_RINCHI_KAIHATSU",
  ADVANCED_SEIBI_JIGYOU: "ADVANCED_SEIBI_JIGYOU",
  ADVANCED_HOANRIN_DAICHO: "ADVANCED_HOANRIN_DAICHO",
};

function getConfig() {
  const xhr = new XMLHttpRequest();
  let result = {};

  xhr.onreadystatechange = () => {
    if (xhr.readyState == 4 && xhr.status == 200) {
      result = JSON.parse(xhr.responseText);
    }
  };

  xhr.open("GET", import.meta.env.VITE_PUBLIC_PATH + "/config.json", false);
  xhr.send(null);

  return result;
}

export const useConstStore = defineStore('const', {
  state: () => ({
    config: getConfig()
  }),
  getters: {
    clientVersion: () => {
      return packageJson.version;
    },
    publicPath: () => {
      return import.meta.env.VITE_PUBLIC_PATH;
    },
    envMode: () => {
      return import.meta.env.VITE_ENV_LABEL;
    },
    featureIconPath() {
      return this.publicPath + "/feature-icon/";
    },
    apiEndpoint: () => {
      return import.meta.env.VITE_API_ENDPOINT;
    },
    homeLng: () => {
      return import.meta.env.VITE_HOMELNG;
    },
    homeLat: () => {
      return import.meta.env.VITE_HOMELAT;
    },
    homeZoom: () => {
      return import.meta.env.VITE_HOMEZOOM;
    },
    myLocationZoom: () => {
      return 15;
    },
    lastUpdate: () => {
      return packageJson.lastupdate;
    },
    managementPath: () => {
      return import.meta.env.VITE_MANAGEMENT_PATH;
    }
  }
});
